import { useMemo } from "react";
import "./SortSelect.css";

export type SortKey = "projectTitle" | "clientName" | "projectNumber";

interface Props {
  sortBy: SortKey;
  setSortBy: (value: SortKey) => void;
  thenBy: SortKey | null;
  setThenBy: (value: SortKey | null) => void;
  isFinance?: boolean;
}

const sortOptions = [
  { value: "projectTitle", label: "Projekttitel" },
  { value: "clientName", label: "Kunde" },
  { value: "projectNumber", label: "Projektnummer" },
];

function SortSelect({ sortBy, setSortBy, thenBy = null, setThenBy, isFinance = false }: Props) {
  const remainderOptions = useMemo(() => {
    return sortOptions.filter((o) => o.value !== sortBy);
  }, [sortBy]);

  return (
    <>
      <div className={`sort-wrapper ${isFinance ? "finance" : ""}`}>
        <div className="sort-container">
          <div className="sort-label">Sortieren nach</div>

          <div className="sort-group">
            {sortOptions.map((option) => (
              <button
                className={`sort-option ${sortBy === option.value ? "active" : ""}`}
                onClick={() => {
                  if (option.value === thenBy) setThenBy(null);
                  setSortBy(option.value as SortKey);
                }}
                key={option.value}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>

        <div className="sort-container">
          <div className="sort-label">und nach</div>

          <div className="sort-group">
            {remainderOptions.map((option) => (
              <button
                className={`sort-option ${thenBy === option.value ? "active" : ""}`}
                onClick={() => {
                  if (option.value === thenBy) setThenBy(null);
                  else setThenBy(option.value as SortKey);
                }}
                key={option.value}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default SortSelect;
